import BorderCard from "components/common/BorderCard";
import ButtonOutline from "components/Semantic/ButtonOutline";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onProceed: () => void;
}

export default function UploadSuccessModal({ isOpen, onClose, onProceed }: Props) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <BorderCard className="relative w-[70%] md:w-[30%] overflow-hidden rounded-xl shadow-xl">
        <div className="flex items-center gap-2 bg-[#FFEFEF] px-5 py-4">
          <p className="text-base text-lg font-semibold">Thank&nbsp;you for submitting your details.</p>
          <button onClick={onClose} className="absolute top-3 right-3 flex h-6 w-6 items-center bg-[#000000] justify-center rounded-full hover:bg-black/10 cursor-pointer text-white hover:text-black">
            x
          </button>
        </div>

        <div className="bg-white ">
          <div className="text-justify px-5 py-5">
            <p className="text-base sm:text-sm font-medium ">We will be launching the Claim&nbsp;Form feature for your Insurance Company soon.</p>
          </div>
          <div className="hidden sm:block border-t border-dashed border-gray-300" />
          <div className="flex justify-center items-center lg:py-4 md:py-4 sm:py-4 py-0">
            <ButtonOutline title="Home" className="text-center w-full sm:w-auto bg-polyfix-gradient border-none rounded-full hover:bg-[#000000] hover:text-white" onClick={onProceed} />
          </div>
        </div>
      </BorderCard>
    </div>
  );
}
